export const engagementsRenewalOrdersMapper = {
  PENDING: 'Pending',
  IN_PROGRESS: 'In Progress',
  RENEWED: 'Renewed',
  DECLINED: 'Declined',
  CANCELED: 'Canceled',
};
